import { ToggleSwitchProps } from '../interface/interface';

const ToggleSwitch = ({
  option1,
  option2,
  isChecked,
  onToggle,
  className,
}: ToggleSwitchProps) => {
  return (
    <div
      className={`flex items-center bg-white border border-primary-blue-500 rounded p-1 ${className}`}
    >
      <div
        className="relative flex items-center w-full bg-white p-2 rounded cursor-pointer"
        onClick={onToggle}
      >
        <div
          className={`absolute w-1/2 h-full bg-secondary-cornflowerblue-400 rounded transition-all duration-300 ${
            isChecked ? 'left-1/2' : 'left-0'
          }`}
        ></div>
        <div
          className={`flex items-center justify-center w-1/2 z-10 transition-colors duration-300 ${
            isChecked ? 'text-primary-blue-500' : 'text-white'
          }`}
        >
          <span className="text-xs">{option1}</span>
        </div>
        <div
          className={`flex items-center justify-center w-1/2 z-10 transition-colors duration-300 ${
            isChecked ? 'text-white' : 'text-primary-blue-500'
          }`}
        >
          <span className="text-xs">{option2}</span>
        </div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
